import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Layout from '../../../components/Layout/Layout';
import api from '../../../api/axios';
import './Trainings.css';

export default function TrainingList() {
  const [trainings, setTrainings] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    api.get('/trainings').then(res => setTrainings(res.data)).finally(() => setLoading(false));
  }, []);

  async function handleDelete(id, title) {
    if (!window.confirm(`Schulung "${title}" wirklich löschen?`)) return;
    await api.delete(`/trainings/${id}`);
    setTrainings(prev => prev.filter(t => t.id !== id));
  }

  return (
    <Layout title="Schulungen">
      <div className="page-header">
        <div />
        <Link to="/admin/trainings/new" className="btn btn-primary btn-sm">+ Neue Schulung</Link>
      </div>

      {loading ? <div>Laden...</div> : (
        <div className="trainings-grid">
          {trainings.map(t => (
            <div key={t.id} className="training-card" onClick={() => navigate(`/admin/trainings/${t.id}`)}>
              <div className="training-card-header">
                <h3 className="training-card-title">{t.title}</h3>
                <span className="training-card-score">{t.passing_score}%</span>
              </div>
              {t.description && <p className="training-card-desc">{t.description.substring(0, 100)}{t.description.length > 100 ? '...' : ''}</p>}
              <div className="training-card-meta">
                <span>📝 {t.questionCount} Fragen</span>
                {t.pdf_original_name && <span>📄 {t.pdf_original_name}</span>}
              </div>
              <div className="training-card-actions" onClick={e => e.stopPropagation()}>
                <Link to={`/admin/trainings/${t.id}/edit`} className="btn btn-ghost btn-sm">Bearbeiten</Link>
                <button className="btn btn-danger btn-sm" onClick={() => handleDelete(t.id, t.title)}>Löschen</button>
              </div>
            </div>
          ))}
          {trainings.length === 0 && (
            <div style={{ textAlign: 'center', padding: '3rem', color: 'var(--gray-dark)' }}>
              Noch keine Schulungen vorhanden.
            </div>
          )}
        </div>
      )}
    </Layout>
  );
}
